import * as React from 'react';
const ChevronDownIcon = (props) => (
	<svg fill="currentColor" viewBox="0 0 14 8" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path d="M7.65 7.69a.91.91 0 0 1-1.29 0L.268 1.603a.913.913 0 0 1 1.29-1.29l5.44 5.44L12.444.31a.913.913 0 0 1 1.29 1.29L7.65 7.69Z" />
	</svg>
);
export default ChevronDownIcon;
